import { useState, useCallback, useEffect } from 'react';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callApi = useCallback(async (apiFunction) => {
    setLoading(true);
    setError(null);
    
    try {
      return await apiFunction();
    } catch (err) {
      setError(err.message || 'API 호출 중 오류가 발생했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, callApi };
};

export const useDataFetch = (fetchFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const { loading, error, callApi } = useApi();

  const fetchData = useCallback(async () => {
    try {
      const result = await callApi(fetchFunction);
      setData(result);
      return result;
    } catch (err) {
      console.error('데이터 페칭 실패:', err);
      throw err;
    }
  }, [fetchFunction, callApi]);

  useEffect(() => {
    fetchData();
  }, dependencies);

  return { data, loading, error, refetch: fetchData };
};
